<template>
  <div class="container">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <div class="col-md-8 offset-md-2">
            <h5 class="card-title">Agregar nuevo almacén</h5>
            <b-form @submit.stop.prevent="onSubmit">
              <b-form-group label-cols-sm="2" label="Nombre*" label-for="input-name">
                <b-form-input
                  id="input-name"
                  name="input-name"
                  type="text"
                  v-model="$v.form.name.$model"
                  :state="validateState('name')"
                ></b-form-input>
                <b-form-invalid-feedback
                  id="input-name-live-feedback"
                >El nombre es requerido.</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group label-cols-sm="2" label="Descripción*" label-for="input-description">
                <b-form-input
                  id="input-description"
                  name="input-description"
                  type="text"
                  v-model="$v.form.description.$model"
                  :state="validateState('description')"
                ></b-form-input>
                <b-form-invalid-feedback id="input-description-live-feedback">La descripción es requerida.</b-form-invalid-feedback>
              </b-form-group>

              <div class="form-group row mt-5">
                <div class="col-sm-12">
                  <b-button type="submit" variant="primary" block>Agregar Proveedor</b-button>
                </div>
              </div>

            </b-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axiosAdelaService from '@/axios/axiosAdelaService'
import mexicosStatesList from '@/mixins/mexicosStatesList'
import mexicoCitiesList from '@/mixins/mexicoCitiesList'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import formatData from '@/mixins/formatAxios'
import {
  BForm,
  BButton,
  BFormGroup,
  BFormInput,
  // BFormSelect,
  BFormInvalidFeedback
} from 'bootstrap-vue'

export default {
  mixins: [validationMixin, formatData],
  components: {
    BForm,
    BButton,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback
    // BFormSelect
  },
  data () {
    return {
      form: {
        name: '',
        description: ''
      },
      stateObject: { name: '', code: '' },
      cityObject: { name: '', id: '' },
      mexicosStatesList: mexicosStatesList,
      mexicoCitiesList: mexicoCitiesList
    }
  },
  validations: {
    form: {
      name: {
        required
      },
      description: {
        required
      }
    }
  },
  methods: {
    showError (msg) {
      this.$toastedPush({
        message: msg,
        type: 'error'
      })
    },
    validateState (name) {
      console.log('name * * *  * ', name)
      const { $dirty, $error } = this.$v.form[name]
      return $dirty ? !$error : null
    },
    async onSubmit () {
      try {
        this.$v.form.$touch()
        if (this.$v.form.$anyError) {
          return
        }
        const request = {
          name: this.form.name,
          description: this.form.description
        }
        const response = await axiosAdelaService.post('/addWerehouse', request)
        if (response.status === 200) {
          this.$toastedPush({
            message: 'Se actualizo la información correctamente.',
            type: 'success'
          })
          this.$router.push({ name: 'warehouse' })
        }
      } catch (error) {
        this.showError('No se pudo agregar la empresa, intentalo mas tarde')
      }
    }
  },
  computed: {
    state: function () {
      return this.stateObject.name
    },
    city: function () {
      return this.cityObject.name
    }
  },
  watch: {
    state (state) {
      this.mexicoCitiesList = this.$_.filter(mexicoCitiesList, ['stateId', this.stateObject.id])
    }
  }
}
</script>

<style>

</style>
